import React from 'react';
import IconBase from './IconBase';

const VideoIcon = props => {
    return (
        <IconBase {...props}>
            {/*<path d="M18,6c-1.7-1.7-3.7-2.5-6-2.5S7.7,4.3,6,6s-2.5,3.7-2.5,6s0.8,4.3,2.5,6s3.7,2.5,6,2.5s4.3-0.8,6-2.5 s2.5-3.7,2.5-6S19.7,7.7,18,6z M15.2,12.6l-4.5,2.9c-0.2,0.2-0.5,0.2-0.8,0c-0.3-0.2-0.4-0.4-0.4-0.7V9.1c0-0.3,0.1-0.5,0.4-0.7 c0.3-0.2,0.5-0.1,0.8,0l4.5,2.9c0.2,0.1,0.3,0.4,0.3,0.6S15.5,12.5,15.2,12.6z"/>*/}
            <path d="M20.5,4H18l2,4h-3.5l-2-4h-2l2,4H11L9,4H7l2,4H5.5l-2-4C2.7,4,2,4.7,2,5.5v13C2,19.3,2.7,20,3.5,20h17 c0.8,0,1.5-0.7,1.5-1.5v-13C22,4.7,21.3,4,20.5,4z M20.5,18.5h-17v-9h17V18.5z"/>
        </IconBase>
    )
}

export default VideoIcon;